import { Paper, useTheme } from "@mui/material";
import { AppointmentformData, InsuranceFormData, resolveEncounterGrouping } from "./fieldData";
import { UseFormReturn } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { useContext, useEffect } from "react";
// import { storageKey } from "../../../utilis/methods/storage/storage";
import { useParams } from "react-router-dom";
import { getAllDepartments, getDoctorsByDepartment,getpostOfficeService, getVisitPurpose } from "../services";
import { getVisitType } from "../../../../EMR/services";
import { FormOnChangeEventType } from "../../../../EMR/types";
import { CustomFormField } from "@utilifiles/component/CustomFormElement";
import { EncounterContextv1,EncounterContextType } from "..";

// 

let gridContainer = "grid grid-cols-2 gap-3 p-2 pb-5 pt-4 ";
function AppointmentForm({ formcontrol }: { formcontrol: UseFormReturn }) {
  const theme = useTheme();
  const { emrno, id } = useParams();
  // const existingEncounter = localStorage.getItem(storageKey.encounterData)
  const { control, setValue, resetField, reset, getValues } = formcontrol;

  const { encounterDetails, searchflag } = useContext(
    EncounterContextv1
  ) as EncounterContextType;

 const { data: listVistType,isLoading:visitTypeLoading } = useQuery(["visitTypeInAppointment"],getVisitType);

  const { mutate: getAllDepartment, data: departmentList } = useMutation(
    getAllDepartments
  );

  const { mutate: getPostOffice, data: postOffice } = useMutation(
    getpostOfficeService
  );

  const { mutate: getDoctor, data: doctorList } = useMutation(getDoctorsByDepartment, {
    onSuccess: (data) => {
      if ((emrno || id) && !searchflag) {
        const doctorItem = data?.response?.find((item: any) => {
          return item.doctorId == encounterDetails?.patientDetails?.doctorId;
        });
        setValue("doctor", doctorItem);
      } else {
        resetField("doctor");
      }
    },
  });
  const { mutate: getPurpose, data: purposeList } = useMutation(
    getVisitPurpose);

  const departmentChange = (event: any) => {
    const deptId = event.target.value.departmentId;
    getDoctor({departmentId: deptId});
  };

  const handlePostOffice = (_: FormOnChangeEventType) => {
    // const {value} = e.target
    const allData = getValues() || {};
    if (allData.PaymentMode == "1") {
      for(let key in allData ){
        if((key as string).includes("deductible") || (key as string).includes("copay")){
            allData[key] = null
        }
      }
      for(let key in InsuranceFormData){
         allData[InsuranceFormData[key as keyof typeof InsuranceFormData].name] = null
      }
      reset({
        ...allData,
      });
    }
  };

  useEffect(() => {
    getAllDepartment();
    getPurpose();
    getPostOffice()
  }, []);

  useEffect(() => {
    const grouping = resolveEncounterGrouping(encounterDetails);
    if (grouping) {
      setValue("grouping", grouping);
    }
  }, [encounterDetails, setValue]);

  useEffect(() => {

    if ((emrno || id) && !searchflag) {
      const visitType=listVistType?.response?.find((item:any)=>{
          return item.id==encounterDetails?.encounter?.visitType
      })
      setValue('visitType', visitType ?? '');

      encounterDetails?.encounter?.departmentId && setValue('department', {
      departmentName: encounterDetails?.encounter?.departmentName ?? '',
      departmentId: encounterDetails?.encounter?.departmentId ?? null,
    });

    setValue('doctor', {
      doctorName: encounterDetails?.encounter?.doctorName ?? '',
    });

    encounterDetails?.encounter?.purposeId && setValue('visitPurpose', {
      purposeName: encounterDetails?.encounter?.purposeName ?? '',
      purposeId: encounterDetails?.encounter?.purposeId ?? null,
    });
     setValue('HIE', encounterDetails?.pmaster?.globalConsent ?? false);
     setValue('ReferenceSource', {type:encounterDetails?.encounter?.knewAbout });
     setValue('refferedby', {clcn_name:encounterDetails?.encounter?.referredBy });

    encounterDetails?.patientDetails?.departmentId && getDoctor({departmentId: encounterDetails?.patientDetails?.departmentId});
   if( encounterDetails?.postOffice?.postofficeId && encounterDetails?.postOffice?.postofficeName){
    setValue("postofficeId", {
      poName: encounterDetails?.postOffice?.postofficeName,
       poId: encounterDetails?.postOffice?.postofficeId
      })
   }
  }
  }, [encounterDetails,listVistType]);
useEffect(()=>{
    const postOfficeData = postOffice?.response?.find((item: any) => {
      return item.poId == encounterDetails?.postOffice?.postofficeId;
    });
    setValue("postofficeId", postOfficeData || postOffice?.response?.[0] || null);
},[encounterDetails,postOffice])
  return (
    <div className="relative pt-3 h-full">
      <Paper className="pt-2 h-full">
        <span
          style={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            zIndex: 99,
          }}
          className="absolute px-2 rounded left-3 top-0 text-md"
        >
          Appointment Details &nbsp;
        </span>
        <div className={gridContainer}>
          <CustomFormField
            control={control}
            options={departmentList?.response||[]}
            {...AppointmentformData.department}
            rules={{
              ...AppointmentformData.department.rules,
              onChange: departmentChange,
            }}
          />
          <CustomFormField
            control={control}
            options={doctorList?.response||[]}
            {...AppointmentformData.doctor}
          />
          <CustomFormField
            control={control}
            options={listVistType?.response || []}
            loading={visitTypeLoading}
            {...AppointmentformData.visitType}
          />
          <CustomFormField
            control={control}
            options={purposeList?.response||[]}
            {...AppointmentformData.visitPurpose}
          />
          <CustomFormField
            control={control}
            options={postOffice?.response||[]}
            {...AppointmentformData.postOffice}
            rules={{
              ...AppointmentformData.postOffice.rules,
              onChange: handlePostOffice,
            }}
          />

          <div>
            <CustomFormField control={control} {...AppointmentformData.HIE} />
          </div>
        </div>
      </Paper>
    </div>
  );
}

export default AppointmentForm;
